import React from 'react';

import Modal from '@ott/modal';

import { PLAY_ICON, VIDEO_PLACEHOLDER, VIDEO_IFRAME_LINK } from '../../../constants';

import styles from './VideoBlock.scss';

const VideoBlock = () => {
  const [isModalOpened, setModalOpened] = React.useState(false);

  return (
    <>
      <Modal
        isOpen={isModalOpened}
        onClose={() => setModalOpened(false)}
        contentOptions={{
          className: styles.modal,
        }}
        children={
          <div data-locator="partnersVideoWrapper" className={styles.videoWrapper}>
            <iframe
              className={styles.video}
              src={VIDEO_IFRAME_LINK}
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen={true}
            />
          </div>
        }
      />

      <div className={styles.videoContainer}>
        <figure className={styles.previewWrapper}>
          <img className={styles.preview} src={VIDEO_PLACEHOLDER} alt="Video Preview" />
        </figure>
        <button
          data-locator="playIcon"
          onClick={() => setModalOpened(true)}
          className={styles.playButton}
        >
          <img className={styles.playIcon} src={PLAY_ICON} alt="Play Icon" />
        </button>
      </div>
    </>
  );
};

export default VideoBlock;
